import { PagedMessageResponse } from 'app/api/types/PagedMessageResponse';
import { FiltroPesquisaFornecedor, Fornecedor } from "app/components/pesquisa-produtos/pesquisa-fornecedor/PesquisaFornecedor"
import { BaseApi } from "./BaseApi"


export class FornecedorApi extends BaseApi {
    async pesquisar(filtro:FiltroPesquisaFornecedor) : Promise<PagedMessageResponse<Fornecedor>> {
        const resposta = await this.api.post(`/Fornecedor/Pesquisar`,filtro)
        return resposta?.data
    }
}